import { Button, Col, Row, Dropdown } from "antd";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { DownOutlined } from "@ant-design/icons";

export default function Header({ leftButton, rightButton }) {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");

  useEffect(() => {
    try {
      const jwt = sessionStorage.getItem("auth");
      const decoded = jwtDecode(jwt);
      setUsername(decoded.username);
    } catch {}
  }, []);

  const logOut = () => {
    sessionStorage.removeItem("auth");
    navigate("/");
  };

  const menuItems = [
    {
      key: "logout",
      label: "Cerrar sesión",
      onClick: logOut,
    },
  ]

  return (
    <header
      style={{
        height: "var(--height-header)",
        background: "var(--color-bg-main)",
        boxShadow: "0 3px 5px rgba(0,0,0,.25)",
        borderBottom: "3px solid var(--color-1)",
        position: "fixed",
        width: "100vw",
        top: 0,
        zIndex: 1000,
      }}
    >
      <Row
        className="container"
        style={{
          height: "100%",
          marginRight: "auto",
          marginLeft: "auto",
          paddingTop: 25,
          paddingBottom: 25,
        }}
        justify="space-between"
        align="middle"
      >
        <Col style={{ height: "70%", display: "flex", alignItems: "center" }}>
          <img
            src="/pok.png"
            alt="Logo PlanOK"
            style={{ maxHeight: "100%", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </Col>
        <Col style={{ height: "100%" }}>
          <Row align="middle" gutter={12} style={{ height: "100%" }}>
            {!!username && (
              <Col>
                <Dropdown menu={{items: menuItems}} placement="bottomRight">
                  <Button
                    type="text"
                    className="text-sm text-bold"
                    style={{ color: "var(--color-1-text)" }}
                  >
                    {username} <DownOutlined className="text-xs" />
                  </Button>
                </Dropdown>
              </Col>
            )}
            <Col style={{ height: "100%", display: "flex", alignItems: "center" }}>
              <img
                src="/valbim.png"
                alt="Logo ValBIM"
                style={{ maxHeight: "75%", cursor: "pointer" }}
                onClick={() => navigate("/")}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </header>
  );
}
